import { addToChainAfter, replaceInChain } from "@insite/client-framework/HandlerCreator";
import {AddFilterCategory, AddStockedItemsFilter, chain, ResetPage} from "@insite/client-framework/Store/Pages/ProductList/Handlers/AddProductFilters";

replaceInChain(chain, ResetPage, props => {
    if (
        props.parameter.pageSize ||
        props.parameter.sort ||
        props.parameter.pageCategoryId ||
        props.parameter.categoryId ||
        props.parameter.stockedItemsOnly !== undefined ||
        props.parameter.previouslyPurchasedProducts !== undefined ||
        props.parameter.searchWithinQueries?.length ||
        props.parameter.brandIds?.length ||
        props.parameter.productLineIds?.length ||
        props.parameter.priceFilters?.length ||
        props.parameter.attributeValueIds?.length ||
        (props.parameter as any).wishlistIds?.length ||
        (props.parameter as any).categoryIds?.length
    ) {
        props.result.page = undefined;
    }
});

replaceInChain(chain, AddFilterCategory, props => {
    const currentFilters = props.getState().pages.productList.productFilters as any;
    (props.result as any).categoryIds = currentFilters.categoryIds;

    if ((props.parameter as any).categoryIds && (props.result as any).categoryIds) {
        (props.result as any).categoryIds = (props.parameter as any).categoryIds.concat((props.result as any).categoryIds || []);
        props.result.categoryId = undefined;
    }

    if((props.parameter as any).categoryIds && !(props.result as any).categoryIds){
        props.result.categoryId = (props.parameter as any).categoryIds[0];        
        (props.result as any).categoryIds = (props.parameter as any).categoryIds;
    }
});

addToChainAfter(chain, AddStockedItemsFilter, props => {
    const currentFilters = props.getState().pages.productList.productFilters as any;
    (props.result as any).wishlistIds = currentFilters.wishlistIds;

    if ((props.parameter as any).wishlistIds) {
        (props.result as any).wishlistIds = (props.parameter as any).wishlistIds.concat((props.result as any).wishlistIds || []);
    }
});

